import { ChangeDetectionStrategy, Component, DestroyRef, Injectable, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AppSettings, Settings } from 'app/app.settings';
import { AuthService } from '@core/auth';
import { ConfigService } from '@core/services';
import { ConfigSettings } from 'environments/ConfigSettings';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  templateUrl: './login-saml-complete.component.html',
  styleUrls: ['./login-saml-complete.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatSidenavModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@Injectable()
export class LoginSamlCompleteComponent implements OnInit {
  title = '';
  config!: ConfigSettings;
  settings: Settings;

  constructor(
    public appSettings: AppSettings,
    private router: Router,
    private configService: ConfigService,
    private authenticationService: AuthService,
    private destroyRef: DestroyRef
  ) {
    this.settings = this.appSettings.settings;
  }

  async ngOnInit(): Promise<void> {
    this.configService.Config.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((config) => {
      if (!config) return;
      this.config = config;
    });

    // get access_token from route:
    const accessToken = this.router.parseUrl(this.router.url).queryParams['access_token'];
    if (accessToken) {
      const auth = await this.authenticationService.samlLoginComplete(accessToken);
      if (auth.successful) {
        this.router.navigate(['/']);
      } else {
        this.router.navigate(['/login'], { queryParams: { error: btoa(auth.message) } });
      }
    }
  }

  public get getLogo(): string {
    return this.config?.logo;
  }

  public get getLoginError(): string {
    // get the error message from the query string
    const base64encoded = this.router.parseUrl(this.router.url).queryParams['error'];
    if (base64encoded) {
      return atob(base64encoded);
    }
    return '';
  }

  public get getClient(): string {
    if (this.config?.environmentName?.includes('local')) {
      return `${this.config?.client} - ${this.config.environmentName}`;
    }
    return this.config?.client ?? '';
  }

  public get getLoginTitle(): string {
    return (this.config?.client ?? '') + ' ' + (this.config?.appName ?? '');
  }
}
